import { render, staticRenderFns } from "./Accordeon.vue?vue&type=template&id=62c22c9a&scoped=true"
import script from "./Accordeon.vue?vue&type=script&lang=js"
export * from "./Accordeon.vue?vue&type=script&lang=js"
import style0 from "./Accordeon.vue?vue&type=style&index=0&id=62c22c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c22c9a",
  null
  
)

export default component.exports